import React, { useEffect, useState } from 'react';
import { useLoading } from '../LoadingContext';  // ★ 変更
import '../../styles/PhotoViewer.css';

const API_BASE = 'https://5uqm251uv5.execute-api.ap-northeast-3.amazonaws.com/prod/api/admin/photos';

const PhotoViewer = ({ userToken, companyToken, onClose }) => {
  const { startLoading, finishLoading } = useLoading();  // ★ 変更
  const [photosByDate, setPhotosByDate] = useState({});

  useEffect(() => {
    const init = async () => {
      startLoading();
      try {
        await loadPhotos();
      } finally {
        finishLoading();
      }
    };
    init();
  }, [userToken]);

  const loadPhotos = async () => {
    const res = await fetch(API_BASE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify({ action: 'list', userToken }),
    });
    const data = await res.json();
    setPhotosByDate(data.photos || {});
  };

  const getPresignedUrl = async (s3Key) => {
    const res = await fetch(API_BASE, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`,
      },
      body: JSON.stringify({ action: 'get-url', s3Key }),
    });
    const { url } = await res.json();
    return url;
  };

  return (
    <div className="photo-viewer-overlay">
      <div className="photo-viewer-modal">
        <button className="photo-viewer-close" onClick={onClose}>×</button>
        <h3>📸 撮影写真一覧（直近10日分）</h3>
        <p>ユーザートークン: {userToken} / 企業トークン: {companyToken}</p>

        <div className="photo-group-container">
          {Object.keys(photosByDate).sort().reverse().map((date) => (
            <div key={date} className="photo-group">
              <h4>📂 {formatDate(date)}</h4>
              <div className="photo-thumbnails">
                {photosByDate[date].map((s3Key) => (
                  <PhotoThumbnail
                    key={s3Key}
                    s3Key={s3Key}
                    getPresignedUrl={getPresignedUrl}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );

  function formatDate(dateStr) {
    return `${dateStr.slice(0, 4)}年${dateStr.slice(4, 6)}月${dateStr.slice(6, 8)}日`;
  }
};

const PhotoThumbnail = ({ s3Key, getPresignedUrl }) => {
  const [url, setUrl] = useState('');

  useEffect(() => {
    let mounted = true;
    getPresignedUrl(s3Key).then(presignedUrl => {
      if (mounted) setUrl(presignedUrl);
    });
    return () => { mounted = false; };
  }, [s3Key]);

  const extractTimeFromKey = (key) => {
    const match = key.match(/\/(\d{8})\/(\d{4})\.jpg$/);
    if (!match) return '';
    const [ , dateStr, timeStr ] = match;
    const yyyy = dateStr.slice(0,4),
          mm   = dateStr.slice(4,6),
          dd   = dateStr.slice(6,8),
          hh   = timeStr.slice(0,2),
          mi   = timeStr.slice(2,4);
    const utcDate = new Date(Date.UTC(+yyyy, +mm-1, +dd, +hh, +mi));
    const jstDate = new Date(utcDate.getTime());
    const jh = String(jstDate.getHours()).padStart(2,'0');
    const jm = String(jstDate.getMinutes()).padStart(2,'0');
    return `${jh}:${jm}`;
  };

  return url ? (
    <div className="photo-thumbnail-item">
      <img
        src={url}
        alt="photo"
        style={{ width: 80, height: 60, objectFit: 'cover' }}
      />
      <div className="photo-timestamp">{extractTimeFromKey(s3Key)}</div>
    </div>
  ) : null;
};

export default PhotoViewer;
